export const MARKET_TABS_EMPTY_TEXT = {
    general:
        "В даний момент у вас немає активних маршрутів (або ж всі маршрути завершені), будь-ласка зверніться до супервайзера.",
    extra: "В даний момент у вас немає позапланових маршрутів, додайте його за необхідності.",
    completed: "В даний момент у вас немає завершених маршрутів.",
};

export const SKIP_POINT_FILES = [
    {
        uid: "0",
        name: "xxx.png",
        status: "uploading",
        percent: 33,
    },
];

export const GEO_OPTIONS = {
    enableHighAccuracy: true,
    timeout: 5000,
    maximumAge: 0,
};
